import { Instagram, Youtube, Twitter, Globe, ArrowUpRight } from "lucide-react";

/**
 * LinkInBio — high-contrast stacked CTA blocks for link-in-bio monetization.
 * Placeholder links for Phase 1.
 */
const LINKS = [
  { label: "Read the 2026 World Cup Hub", icon: Globe, testId: "linkinbio-worldcup" },
  { label: "Subscribe to the AI Daily Digest", icon: ArrowUpRight, testId: "linkinbio-digest" },
  { label: "Follow on YouTube", icon: Youtube, testId: "linkinbio-youtube" },
  { label: "Follow on X", icon: Twitter, testId: "linkinbio-x" },
  { label: "Follow on Instagram", icon: Instagram, testId: "linkinbio-instagram" },
];

export const LinkInBio = () => {
  return (
    <div className="mx-auto flex w-full max-w-lg flex-col gap-3" data-testid="link-in-bio">
      {LINKS.map((l) => (
        <a
          key={l.testId}
          href="#"
          data-testid={l.testId}
          className="group flex items-center justify-between rounded-lg border border-brand-navy bg-brand-navy/40 px-5 py-4 text-sm font-semibold tracking-wide text-white transition-all duration-300 hover:border-transparent hover:bg-brand-royal"
        >
          <span className="flex items-center gap-3">
            <l.icon className="h-4 w-4 text-brand-cyan transition-colors duration-300 group-hover:text-white" />
            {l.label}
          </span>
          <ArrowUpRight className="h-4 w-4 text-brand-silver transition-all duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-white" />
        </a>
      ))}
    </div>
  );
};

export default LinkInBio;
